<script>
    import MetisMenu from "metismenujs/dist/metismenujs";
    import UserMeta from "@/mixins/usermeta.mixin";

    // import { menuItems } from "./menu";

    import Resource from '@/api/resource';
    const menuResource = new Resource('api/ajax/get_menu');

    export default {
        mixins: [UserMeta],
        data() {
            return {
                menuItems: null,
                /*
                 * Assets Film & TV, Pass 2, batch 3 (T4 item 1, Log #280). ONE FLAT USER-META KEY
                 * holding a map of navigation item id to open or closed.
                 *
                 * FLAT, and that is T10's rule, not a preference: `save_meta_value` reads a DOT in a
                 * key as a path and nests what follows, so `side_nav.open` would write a nested object
                 * and never read back as one key.
                 */
                side_nav_open_key: 'side_nav_open',
                /*
                 * The state this component DREW, per navigation item id, and the guard against saving
                 * a state nobody chose.
                 *
                 * MetisMenu's own `init()` calls `show()` on every sub-menu whose `li` it finds marked
                 * active -- which, since T4 item 2, is the one the pivot declares open by default --
                 * and that emits `shown.metisMenu` like any other opening. Without this the default
                 * would be written into every user's profile on every page load, turning a declared
                 * default into a saved choice the first time anyone loaded a page. A save is made only
                 * where the new state DIFFERS from the one drawn.
                 */
                drawn_sub_menu_state: {},
                /** The site's own default accent, used where the entity has no colour plate. */
                default_accent_colour: '#556ee6',
            };
        },
        computed: {
            /**
             * Entry 6 of `walk/2026-09-28/HANDOFF_ABED_2026-09-28.md` (2026-09-28 12:43Z, D2 option 1,
             * unit B3E6): THE COMPACT ROWS ARE THE CURATED MODULE'S ONLY. True when the selected module
             * has `uses_curated_screens`, read from the shared mixin exactly as every other curated gate
             * reads it (`usermeta.mixin.js`, `this.uses_curated_screens = this.current_module_info
             * .uses_curated_screens`, the module `window.USER_INFO.current_module` names); never a module
             * id, and never the count of headings (Administration has a heading of its own). The
             * template writes `side-menu--compact` on the menu from it, and `_vertical.scss` keys the
             * compact rows on that class; without it every other module's menu draws the theme's rows,
             * as before the rollout. SHARED by nature: module 23, Costume and Administration change back.
             */
            compactMenu() {
                return !!this.uses_curated_screens;
            },
            /**
             * The id of the view the user's profile holds, or 0 (Overview) where it holds nothing.
             *
             * T7 item 2 (Log #282). `preferred_view` is the view OBJECT the assets list writes,
             * `{id, name}` (`ViewOptions.js`), and it is one key for every module.
             */
            currentViewId() {
                let user_meta = this.userMeta();
                let preferred = user_meta ? user_meta.preferred_view : null;

                if (preferred && typeof preferred === 'object' && preferred.id !== undefined && preferred.id !== null) {
                    let id = parseInt(preferred.id);
                    return isNaN(id) ? 0 : id;
                }

                return 0;
            },
            /**
             * The entity's accent, handed to the "current" tag's own rule as a custom property.
             *
             * `window.COLOUR_PLATE` is written by `app.blade.php` and EXISTS ONLY FOR AN ENTITY THAT
             * HAS A PRIMARY COLOUR, so the fall-back is the site's own default primary and not any
             * customer's colour. The rest of the tag's style is `.side-nav-current-view` below, which
             * is where T7 item 2's declarations live: this component's own styles, never the Film & TV
             * Dashboard's stylesheet.
             */
            currentViewTagStyle() {
                let plate = (typeof window !== 'undefined' && window.COLOUR_PLATE) ? window.COLOUR_PLATE : null;
                let accent = (plate && plate.accent_colour) ? plate.accent_colour : this.default_accent_colour;

                return { '--side-nav-current-accent': accent };
            },
        },
        created() {
            this.getMenu();
        },
        methods: {
            refreshMenu(){
                this.menuItems = null;
                this.getMenu();
            },
            /**
             * Returns true or false if given menu item has child or not
             * @param item menuItem
             */
            hasItems(item) {
                return item.subItems !== undefined ? item.subItems.length > 0 : false;
            },

            // --------------------------------------------------------------------------------------
            // T7 item 2: which sub-entry is the user's view (Log #282)
            // --------------------------------------------------------------------------------------

            /** The page's own copy of the user's profile, or null. */
            userMeta() {
                let user_info = (typeof window !== 'undefined' && window.USER_INFO) ? window.USER_INFO : null;
                return (user_info && user_info.user_meta) ? user_info.user_meta : null;
            },

            /**
             * The view id a navigation link selects, or null where it selects none.
             *
             * MATCHED ON THE ID PARSED FROM THE EMITTED LINK AND NEVER ON THE LABEL (T7 item 2): the
             * view is "Label" and the entry is "Labels", and `NavigationItem.php` prefixes the link
             * with the entity, which leaves the query alone -- so the query is the one thing that is
             * the same before and after the prefix.
             */
            viewIdOfLink(link) {
                if (!link) {
                    return null;
                }

                let found = /[?&]v=([^&#]*)/.exec(String(link));
                if (!found || found[1] === '') {
                    return null;
                }

                let id = parseInt(found[1]);
                return isNaN(id) ? null : id;
            },

            /** Whether this sub-entry opens the view the user's profile holds. */
            isCurrentView(subitem) {
                let id = this.viewIdOfLink(subitem ? subitem.link : null);
                return id !== null && id === this.currentViewId;
            },

            // --------------------------------------------------------------------------------------
            // T4: what is open, remembered (Log #280)
            // --------------------------------------------------------------------------------------

            /**
             * The user's saved open/closed map, keyed by `navigation_items.id`.
             *
             * An absent key means "nothing saved for this parent", which is what lets the declared
             * default (`is_open_by_default`) and the active-page walk apply. A PHP empty map comes back
             * as `[]`, and a profile that has never been written comes back undefined; both read as an
             * empty map here.
             */
            savedSubMenuState() {
                let user_meta = this.userMeta();
                let saved = user_meta ? user_meta[this.side_nav_open_key] : null;

                if (typeof saved === 'string') {
                    try {
                        saved = JSON.parse(saved);
                    } catch (error) {
                        saved = null;
                    }
                }

                return (saved && typeof saved === 'object') ? saved : {};
            },

            /** Whether the user has stated an open state for this parent. */
            savedStateHas(saved, id) {
                return id !== null && id !== '' && Object.prototype.hasOwnProperty.call(saved, id);
            },

            /**
             * Every top-level row that holds a sub-menu, as {li, sub, id}.
             *
             * Walked over `children` rather than `querySelectorAll(':scope > ...')` so the component
             * asks nothing of the browser that the sidebar's oldest supported one cannot answer.
             */
            subMenuParents() {
                let parents = [];
                let menu = document.getElementById('side-menu');
                if (!menu) {
                    return parents;
                }

                for (let i = 0; i < menu.children.length; i++) {
                    let li = menu.children[i];
                    if (li.tagName !== 'LI') {
                        continue;
                    }

                    let sub = null;
                    for (let c = 0; c < li.children.length; c++) {
                        let child = li.children[c];
                        if (child.tagName === 'UL' && child.classList.contains('sub-menu')) {
                            sub = child;
                            break;
                        }
                    }

                    if (sub) {
                        parents.push({ li: li, sub: sub, id: li.getAttribute('data-nav-item-id') });
                    }
                }

                return parents;
            },

            /** The disclosure controls of a parent row: the arrow, or the whole row where it has no link. */
            subMenuToggles(li) {
                let toggles = [];
                for (let c = 0; c < li.children.length; c++) {
                    let child = li.children[c];
                    if (child.tagName === 'A'
                        && (child.classList.contains('side-nav-toggle') || child.classList.contains('has-arrow'))) {
                        toggles.push(child);
                    }
                }
                return toggles;
            },

            /**
             * Whether the active-page walk above marked this parent: either it put `mm-show` on the
             * sub-menu, because the page is one of the sub-entries, or it put `mm-active` on the `li`,
             * because the page is the parent's OWN link (All Files on `/customer/files`).
             *
             * MetisMenu has not bound when this is asked, and nothing else writes either class before
             * it, so both can only have come from the walk.
             */
            activePageMarkedParent(parent) {
                return parent.sub.classList.contains('mm-show')
                    || parent.li.classList.contains('mm-active');
            },

            /**
             * Draw a parent open or closed, in the classes MetisMenu itself uses, so that when it binds
             * a moment later it finds a menu already in the state it would have put it in.
             *
             * `mm-active` ON THE `li` IS ONE FLAG WITH TWO MEANINGS and they are not separable from
             * here: `metismenujs`'s `init()` reads `li.classList.contains('mm-active')` to decide
             * whether to show a sub-menu, and its `toggle()` reads the same class, while the theme
             * paints the active row through it alone (`_vertical.scss:219`, `:502`, `:621`, `:675`,
             * and on the live dark sidebar `app.blade.php:390-392`, whose colours are blade-
             * interpolated with `!important` against `li:not(.mm-active) a` at `:382-384`, in a file
             * this piece must not edit). So a parent drawn CLOSED cannot keep the class, and the rule
             * that keeps the active mark is in `applySubMenuState()` below: the walk's mark is a
             * reason to open.
             */
            setSubMenuOpen(parent, open) {
                let toggles = this.subMenuToggles(parent.li);

                if (open) {
                    parent.sub.classList.add('mm-show');
                    parent.li.classList.add('mm-active');
                } else {
                    parent.sub.classList.remove('mm-show');
                    parent.li.classList.remove('mm-active');
                }

                for (let i = 0; i < toggles.length; i++) {
                    if (open) {
                        toggles[i].classList.add('mm-active');
                    } else {
                        toggles[i].classList.remove('mm-active');
                    }
                    toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
                }
            },

            /**
             * T4 item 3, THE RULE: THE SAVED STATE WINS, THEN THE PAGE, THEN THE DECLARED DEFAULT.
             *
             * A user who closed the views and then opens the assets list must find them still closed,
             * so a saved value is the answer wherever there is one.
             *
             * WHERE NOTHING IS SAVED THE PAGE COMES BEFORE THE DEFAULT, which is item 3's own last
             * sentence: "A user who has saved nothing gets the default, and ON A PAGE INSIDE A
             * CLOSED-BY-DEFAULT SUB-MENU IT OPENS AS IT DOES TODAY." Read the other way round -- the
             * default closing a parent the walk had marked -- the row the user is on loses `mm-active`
             * and with it the whole active-row highlight, because that class is the only thing the
             * theme paints it through (see `setSubMenuOpen()` above). It is the parent's OWN page that
             * is the sharp case: on `/customer/files` the walk marks All Files' `li` and never touches
             * the sub-menu, so `mm-show` alone does not see it, which is why `activePageMarkedParent()`
             * asks for both.
             */
            applySubMenuState(saved) {
                let parents = this.subMenuParents();

                for (let i = 0; i < parents.length; i++) {
                    let parent = parents[i];
                    let open;

                    if (this.savedStateHas(saved, parent.id)) {
                        open = !!saved[parent.id];
                    } else {
                        open = this.activePageMarkedParent(parent)
                            || parent.li.getAttribute('data-open-by-default') === '1';
                    }

                    this.setSubMenuOpen(parent, open);

                    if (parent.id) {
                        this.drawn_sub_menu_state[parent.id] = open ? 1 : 0;
                    }
                }
            },

            /**
             * Save one parent's new state, SILENTLY (T4 item 1: no toast).
             *
             * `set_usermeta`'s third argument is the success message and an empty one shows nothing,
             * which is the behaviour this item asks for: opening a sub-menu is not an action a user
             * wants confirmed. The map is written whole, and `window.USER_INFO` is updated in memory
             * so a second toggle on the same page writes the whole map and not half of it.
             */
            rememberSubMenuState(ul, is_open) {
                let li = ul ? ul.parentElement : null;
                let id = li ? li.getAttribute('data-nav-item-id') : null;
                if (!id) {
                    return;
                }

                let is_open_value = is_open ? 1 : 0;

                /*
                 * MetisMenu re-states the drawn state on bind (see `drawn_sub_menu_state`), so an event
                 * that says what is already on screen is not a choice and is not written.
                 */
                if (Object.prototype.hasOwnProperty.call(this.drawn_sub_menu_state, id)
                    && this.drawn_sub_menu_state[id] === is_open_value) {
                    return;
                }
                this.drawn_sub_menu_state[id] = is_open_value;

                let state = this.savedSubMenuState();
                state[id] = is_open_value;

                if (window.USER_INFO) {
                    if (!window.USER_INFO.user_meta) {
                        window.USER_INFO.user_meta = {};
                    }
                    window.USER_INFO.user_meta[this.side_nav_open_key] = state;
                }

                this.set_usermeta(this.side_nav_open_key, state, '');
            },

            async listItems(){
                var links = await document.getElementsByClassName("side-nav-link-ref");
                var matchingMenuItem = null;
                const paths = [];
                const paths_with_search = [];

                /*
                 * T4 (Log #280). READ BEFORE ANYTHING IS MARKED, because the saved state is what
                 * decides whether the active-page walk below may open a sub-menu at all.
                 */
                const saved_sub_menu_state = this.savedSubMenuState();

                for (var i = 0; i < links.length; i++) {
                    let my_link = links[i];
                    paths.push(my_link["pathname"]);
                    paths_with_search.push(my_link["pathname"] + my_link["search"]);
                }

                let first_path = window.location.pathname + window.location.search;

                var itemIndex = paths_with_search.indexOf(first_path);

                if (itemIndex === -1) {
                    itemIndex = paths.indexOf(window.location.pathname);
                }

                if (itemIndex === -1) {
                    const strIndex = window.location.pathname.lastIndexOf("/");
                    const item = window.location.pathname.substr(0, strIndex).toString();
                    matchingMenuItem = links[paths.indexOf(item)];
                } else {
                    matchingMenuItem = links[itemIndex];
                }

                if (matchingMenuItem) {
                    matchingMenuItem.classList.add("active");
                    var parent = matchingMenuItem.parentElement;

                    /**
                     * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
                     * We should come up with non hard coded approach
                     */
                    if (parent) {
                        parent.classList.add("mm-active");
                        const parent2 = parent.parentElement.closest("ul");
                        if (parent2 && parent2.id !== "side-menu") {
                            /*
                             * T4 item 3 (Log #280). THIS ADD WAS UNCONDITIONAL, and that is the "it
                             * opens by itself on a page inside it" of the task's Seen. A user who
                             * CLOSED the views and then opened the assets list found them open again,
                             * so the page's own walk now yields to a saved closed state.
                             *
                             * The active view's own mark is untouched either way: it is the `active`
                             * class on the anchor above and the `mm-active` on its own `li`, neither of
                             * which this decides.
                             */
                            const parent2_li = parent2.parentElement;
                            const parent2_id = parent2_li ? parent2_li.getAttribute('data-nav-item-id') : null;
                            const saved_closed = this.savedStateHas(saved_sub_menu_state, parent2_id)
                                && !saved_sub_menu_state[parent2_id];

                            if (!saved_closed) {
                                parent2.classList.add("mm-show");
                            }

                            const parent3 = parent2.parentElement;
                            if (parent3) {
                                parent3.classList.add("mm-active");
                                var childAnchor = parent3.querySelector(".has-arrow");
                                var childDropdown = parent3.querySelector(".has-dropdown");
                                if (childAnchor) childAnchor.classList.add("mm-active");
                                if (childDropdown) childDropdown.classList.add("mm-active");

                                const parent4 = parent3.parentElement;
                                if (parent4 && parent4.id !== "side-menu") {
                                    parent4.classList.add("mm-show");
                                    const parent5 = parent4.parentElement;
                                    if (parent5 && parent5.id !== "side-menu") {
                                        parent5.classList.add("mm-active");
                                        const childanchor = parent5.querySelector(".is-parent");
                                        if (childanchor && parent5.id !== "side-menu") {
                                            childanchor.classList.add("mm-active");
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                /*
                 * T4 items 2 and 3 (Log #280): the saved state, then the declared default, applied to
                 * EVERY parent -- including the ones the walk above said nothing about -- and applied
                 * BEFORE MetisMenu binds, so a sub-menu is never drawn in one state and then moved to
                 * the other.
                 */
                this.applySubMenuState(saved_sub_menu_state);

                /*
                 * Assets Film & TV, Pass 2 (Log #238, #250). THE TRIGGER IS THE ARROW, NOT ANY ANCHOR.
                 *
                 * MetisMenu takes `li.querySelector(triggerElement)` for each `li` that holds a sub-menu and
                 * calls `preventDefault()` on its click, so with `triggerElement: 'a'` the first anchor in
                 * the row is swallowed -- which is exactly the anchor a parent like All Assets needs to
                 * navigate. Pointing it at the arrow's own class leaves the parent's link a link and makes
                 * the arrow the control.
                 *
                 * IT CHANGES NOTHING FOR ANY OTHER MODULE: MetisMenu only touches an `li` that contains a
                 * `ul`, no payload emitted `subItems` before this wave, and so no sidebar in the application
                 * had a nested `ul` for it to bind at all.
                 */
                var menuRef = new MetisMenu("#side-menu", {
                    toggle: false,
                    triggerElement: '.side-nav-toggle',
                    parentTrigger: 'li',
                    subMenu: 'ul'
                });

                /*
                 * T4 item 1 (Log #280): the two moments to save. MetisMenu dispatches these on the menu
                 * element itself once the height transition has finished, with the sub-menu in
                 * `detail.shownElement` / `detail.hiddenElement`, so the state saved is the settled one
                 * and a click that MetisMenu refused (mid-transition) writes nothing.
                 */
                const menu_element = document.getElementById('side-menu');
                if (menu_element) {
                    menu_element.addEventListener('shown.metisMenu', (event) => {
                        this.rememberSubMenuState(event.detail ? event.detail.shownElement : null, true);
                    });
                    menu_element.addEventListener('hidden.metisMenu', (event) => {
                        this.rememberSubMenuState(event.detail ? event.detail.hiddenElement : null, false);
                    });
                }
            },
            async getMenu() {
                const { data } = await menuResource.list();
                this.menuItems = data.data.items;
                await this.listItems();
            }
        },
    };
</script>

<template>
    <!-- ========== Left Sidebar Start ========== -->

    <!--- Sidemenu -->
    <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <!--
            `side-menu--compact` (entry 6 of the 2026-09-28 hand-off, unit B3E6): the curated module's
            compact rows, keyed in `_vertical.scss` and in the arrow's rule below. The loading menu under
            `v-else` draws no rows (one heading with a spinner), so it carries no class.
        -->
        <ul v-if="menuItems" id="side-menu" class="metismenu list-unstyled" :class="{'side-menu--compact': compactMenu}">
            <template v-for="item in menuItems">
                <li class="menu-link-title" v-if="item.isTitle && item.link !== ''" :key="item.id">
                    <a :href="item.link">{{ $t(item.label) }}</a>
                </li>
                <li class="menu-title" v-else-if="item.isTitle" :key="item.id">{{ $t(item.label) }}</li>
                <!--
                    `data-nav-item-id` and `data-open-by-default` (T4, Log #280). The open state is a
                    fact about a NAVIGATION ITEM and is saved under its id, so the id has to survive
                    into the DOM: `:key` does not render. `is_open_by_default` is the pivot column the
                    installer sets for ASSETS' All Assets alone, and the payload omits it everywhere
                    else, so every other row reads "closed" exactly as it did before.
                -->
                <li
                    v-if="!item.isTitle && !item.isLayout"
                    :key="item.id"
                    :class="{'side-nav-parent-with-link': hasItems(item) && item.link}"
                    :data-nav-item-id="item.id"
                    :data-open-by-default="item.is_open_by_default ? '1' : '0'"
                >
                    <!--
                        A parent with no link of its own: the whole row is the disclosure control, as it
                        always was.
                    -->
                    <a
                        v-if="hasItems(item) && !item.link"
                        href="javascript:void(0);"
                        class="is-parent side-nav-toggle"
                        :class="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
                    >
                        <i :class="`nav-item-icon ${item.icon}`" v-if="item.icon"></i>
                        <span>{{ $t(item.label) }}</span>
                        <span
                            :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                            v-if="item.badge"
                        >{{ $t(item.badge.text)}}</span>
                    </a>

                    <!--
                        Assets Film & TV, Pass 2 (Log #250): "a parent that carries its own link (All
                        Assets) renders its anchor beside the disclosure arrow". Two anchors, both direct
                        children of the li: the first navigates and carries `side-nav-link-ref` so
                        `listItems()` can mark it active, the second is the arrow and is the only one
                        MetisMenu binds (see `side-nav-toggle` in listItems()). Before this the parent's
                        link was thrown away -- `:href` was rendered only `v-if="!hasItems(item)"` -- so a
                        parent could not be opened at all.
                    -->
                    <a
                        v-if="hasItems(item) && item.link"
                        :href="item.link"
                        class="is-parent side-nav-parent-link"
                        :class="(item.is_url ? 'side-nav-link-custom-url' : 'side-nav-link-ref') + (item.is_condensed ? ' side-nav-condensed' : '')"
                    >
                        <i :class="`nav-item-icon ${item.icon}`" v-if="item.icon"></i>
                        <span>{{ $t(item.label) }}</span>
                    </a>
                    <a
                        v-if="hasItems(item) && item.link"
                        href="javascript:void(0);"
                        class="side-nav-toggle side-nav-parent-toggle has-arrow"
                        :aria-label="$t(item.label)"
                    ></a>

                    <a :href="item.link" v-if="!hasItems(item)" :class="(item.is_url ? 'side-nav-link-custom-url' : 'side-nav-link-ref') + (item.is_condensed ? ' side-nav-condensed' : '')">
                        <i :class="`nav-item-icon ${item.icon}`" v-if="item.icon"></i>
                        <span>{{ $t(item.label) }}</span>
                        <span
                            :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                            v-if="item.badge"
                        >{{$t(item.badge.text)}}</span>
                    </a>

                    <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                        <li v-for="(subitem, index) of item.subItems" :key="index">
                            <!--
                                T2 item 2 (Log #278). EVERY SUB-ENTRY DRAWS THE SAME WAY: a dash icon
                                before the label, and `side-nav-condensed` no longer applied.

                                THE ICON. The six views are module 23's own catalogue rows and carry
                                `bx bx-minus` of their own; Imports and Exports carry none, and the
                                FALL-BACK IS HERE AND NOT IN THE PAYLOAD -- `NavigationItem.php` sets
                                `icon` for every module and must go on emitting exactly what it emits
                                today.

                                THE CLASS THAT LEFT. `side-nav-condensed`'s rule is not in this
                                repository: it comes from the CloudFront stylesheets the layout loads,
                                which production loads too, so it cannot be changed -- and the rows'
                                own `is_condensed` is module 23's, so that is not the thing to change
                                either. The class is simply no longer put on a sub-entry, which is what
                                stops the external rule pulling the six views left of their parent's
                                own label. Module 23 draws these same rows as TOP-LEVEL entries, where
                                the class is still applied above.
                            -->
                            <a
                                :href="subitem.link"
                                v-if="!hasItems(subitem)"
                                :class="subitem.is_url ? 'side-nav-link-custom-url' : 'side-nav-link-ref'"
                            >
                                <i :class="`nav-item-icon ${subitem.icon ? subitem.icon : 'bx bx-minus'}`"></i>
                                <span class="side-nav-sub-label">{{ $t(subitem.label) }}</span>
                                <!--
                                    T7 item 2 (Log #282): the tag says which view All Assets and every
                                    Dashboard link will open in. It is NOT the active-page mark, which
                                    says which page is open; both can show at once.
                                -->
                                <span
                                    v-if="isCurrentView(subitem)"
                                    class="side-nav-current-view"
                                    :style="currentViewTagStyle"
                                >current</span>
                            </a>
                            <a
                                v-if="hasItems(subitem)"
                                class="side-nav-link-a-ref has-arrow side-nav-toggle"
                                href="javascript:void(0);"
                            >{{ $t(subitem.label) }}</a>
                            <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                                <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                                    <!--
                                        A level deeper than T2 item 2's own line, and changed with it
                                        for consistency: NO PAYLOAD EMITS A SUB-SUB-ENTRY today (the
                                        component's comment in listItems() says why), so this is
                                        expected to have no visible effect anywhere.
                                    -->
                                    <a :href="subSubitem.link" :class="subSubitem.is_url ? 'side-nav-link-custom-url' : 'side-nav-link-ref'">{{ $t(subSubitem.label) }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
        <ul v-else id="loading-side-menu" class="metismenu list-unstyled">
            <li class="menu-title text-center">
                <b-spinner class="text-af-accent m-2"></b-spinner>
                <h4 class="text-white">Loading...</h4>
            </li>
        </ul>
    </div>
    <!-- Sidebar -->
</template>

<style>
/*
 * Assets Film & TV, Pass 2 (Log #238, #250): the disclosure arrow of a parent entry that carries its own
 * link, e.g. All Assets under ASSETS. The arrow is a second anchor beside the link -- it cannot be inside
 * a wrapper, because MetisMenu reads `ev.currentTarget.parentNode` as the `li` -- so it is taken out of
 * the flow and laid over the right-hand end of the row.
 *
 * `top: 0` with the row's own padding rather than `bottom: 0` or `height: 100%`: the `li` grows to hold the
 * open sub-menu, and a full-height arrow would swallow clicks on every sub-entry in it.
 */
#sidebar-menu .side-nav-parent-with-link {
    position: relative;
}

#sidebar-menu .side-nav-parent-with-link > .side-nav-parent-link {
    /* room for the arrow, so a long label never runs under it */
    padding-right: 3.5rem;
}

#sidebar-menu .side-nav-parent-with-link > .side-nav-parent-toggle {
    position: absolute;
    top: 0;
    right: 0;
    width: 3.5rem;
    /*
     * T1 point 1 (Log #277): THE SAME VERTICAL PADDING AS THE ROW, which is `_vertical.scss`'s
     * `#sidebar-menu ul li a`. This box repeats the row's padding by hand, so left at `.625rem` it
     * would be a 43 pixel box over a 28 pixel row -- lying over the right-hand end of the row BENEATH
     * and taking that row's click.
     *
     * Entry 6 of the 2026-09-28 hand-off (unit B3E6): the row is the theme's `.625rem` again on every
     * module but the curated one, so this box is too (the value it had before T1, `7691b9af0`), and the
     * compact `.1rem` follows the same switch in the rule below. SHARED by nature.
     */
    padding: .625rem 1.5rem .625rem 0;
    /*
     * FIX PASS, F65 (NAV-006). THE BOX IS THE HEIGHT OF ITS ROW, and the 2.5 pixels it was short by
     * are the entry icon's.
     *
     * Read on the branch: the arrow box 25.7px against its row's 28.2px. T1's padding change landed
     * -- both are `.1rem` top and bottom, 1.6px each -- so the difference is entirely in the line
     * box between them. The row's line box is the entry's `<i>`: `_vertical.scss` gives it
     * `line-height: 1.40625rem` (22.5px) AND `padding-bottom: .125em` at `font-size: 1.25rem`
     * (2.5px), so the row's content is 25px and the row is 28.2px. This box has no icon in it, only
     * the chevron `#sidebar-menu .has-arrow:after` draws, so at a bare `1.40625rem` its content was
     * 22.5px and the box 25.7px.
     *
     * The value below is those two numbers added, written as the sum so it stays tied to the rule it
     * follows rather than becoming a third literal: if the entry's line-height or the icon's
     * padding moves in `_vertical.scss`, this is the sum to move with it. The chevron is
     * `display: block; float: right` and this element is `position: absolute`, which makes it a
     * block formatting context, so the float's own height -- this line-height -- is what the box
     * takes, and 25 + 1.6 + 1.6 is the row's own 28.2px.
     *
     * SHARED: this is the application's one side navigation, so the arrow reaches its row's height on
     * module 23 and the Costume module too, wherever a parent entry carries its own link.
     */
    line-height: calc(1.40625rem + 0.15625rem);
    cursor: pointer;
}

/*
 * Entry 6 (unit B3E6): the curated module's compact row, `_vertical.scss`'s `.1rem`, keyed on the class
 * the template writes from `uses_curated_screens`. The line height above is the row's content in both
 * states (the entry icon's box), so only the padding switches: 28.2 against 28.2, 45 against 45.
 * `:where()` as in `_vertical.scss`: the rule outweighs the one above by one element and no more, so the
 * collapsed sidebar's own row rule (`.vertical-collpsed ... > ul > li > a`, (1,2,3)) still wins over it.
 */
#sidebar-menu ul:where(#side-menu.side-menu--compact) .side-nav-parent-with-link > .side-nav-parent-toggle {
    padding: .1rem 1.5rem .1rem 0;
}

/*
 * T2 item 1's HOVER lives in `_vertical.scss`, beside the chevron rule it recolours, because the colour
 * it uses is `$sidebar-menu-item-hover-color` -- the hover colour the entries themselves use -- and this
 * block is plain CSS with no Sass variables in scope. The pointer is here, on the rule above, and was
 * already built (T2 item 1's third clause).
 */

/*
 * The collapsed sidebar (`.vertical-collpsed`, the theme's own spelling) is 70px wide and hides the
 * chevron altogether (`_vertical.scss`: `.has-arrow { &:after { display: none } }`). A 3.5rem invisible
 * box over half of a 70px row would swallow the click that opens the page, so on that layout the arrow
 * goes and the row is the link again -- which is what the collapsed sidebar does with its hover-out
 * sub-menus anyway.
 */
.vertical-collpsed #sidebar-menu .side-nav-parent-with-link > .side-nav-parent-toggle {
    display: none;
}

.vertical-collpsed #sidebar-menu .side-nav-parent-with-link > .side-nav-parent-link {
    padding-right: 1.5rem;
}

/*
 * T7 item 2 (Log #282): the "current" tag, in the style the task states exactly. It lives HERE, in this
 * component's own styles -- it is the mock's `.side .cur`, which belongs to the mock's shell and not to
 * the Film & TV Dashboard's stylesheet, which this piece does not ship and does not touch.
 *
 * The background is the ENTITY'S ACCENT, handed in as a custom property by `currentViewTagStyle` because
 * it is only known at run time (`window.COLOUR_PLATE`); the fall-back is the site's own default primary,
 * which is what the site falls back to for an entity with no colour plate.
 */
.side-nav-current-view {
    margin-left: 6px; padding: 0 6px; border-radius: 8px; background: var(--side-nav-current-accent, #556ee6); color: #fff; font-size: 10px; font-weight: 500;
}
</style>
